export * from './cs-player.component';



// WEBPACK FOOTER //
// ./src/app/components/cs-player/index.ts